export default __webpack_public_path__ + "static/media/ellipse-purple.eab75b69.svg";